import { Moment } from 'moment-timezone';

const MIN_YEAR = 2007;
const MAX_YEAR = 2026;
const SUPPORTED_TZ = "Europe/Budapest";

export const SPECIAL_DAYS: { [key: string]: boolean } = {
  "2007-01-01": false,
  "2007-03-10": true,
  "2007-03-15": false,
  "2007-03-16": false,
  "2007-04-09": false,
  "2007-04-21": true,
  "2007-04-30": false,
  "2007-05-01": false,
  "2007-05-28": false,
  "2007-08-20": false,
  "2007-10-20": true,
  "2007-10-22": false,
  "2007-10-23": false,
  "2007-10-27": true,
  "2007-11-01": false,
  "2007-11-02": false,
  "2007-12-22": true,
  "2007-12-24": false,
  "2007-12-25": false,
  "2007-12-26": false,
  "2007-12-29": true,
  "2007-12-31": false,
  "2008-01-01": false,
  "2008-03-24": false,
  "2008-04-26": true,
  "2008-05-01": false,
  "2008-05-02": false,
  "2008-05-12": false,
  "2008-08-20": false,
  "2008-10-18": true,
  "2008-10-23": false,
  "2008-10-24": false,
  "2008-12-20": true,
  "2008-12-24": false,
  "2008-12-25": false,
  "2008-12-26": false,
  "2009-01-01": false,
  "2009-01-02": false,
  "2009-03-28": true,
  "2009-04-13": false,
  "2009-05-01": false,
  "2009-06-01": false,
  "2009-08-20": false,
  "2009-08-21": false,
  "2009-08-29": true,
  "2009-10-23": false,
  "2009-12-19": true,
  "2009-12-24": false,
  "2009-12-25": false,
  "2009-12-26": false,
  "2010-01-01": false,
  "2010-03-15": false,
  "2010-04-05": false,
  "2010-05-01": false,
  "2010-05-24": false,
  "2010-08-20": false,
  "2010-10-23": false,
  "2010-11-01": false,
  "2010-12-11": true,
  "2010-12-24": false,
  "2011-03-14": false,
  "2011-03-15": false,
  "2011-03-19": true,
  "2011-04-25": false,
  "2011-06-13": false,
  "2011-10-31": false,
  "2011-11-01": false,
  "2011-11-05": true,
  "2011-12-26": false,
  "2012-03-15": false,
  "2012-03-16": false,
  "2012-03-24": true,
  "2012-04-09": false,
  "2012-04-21": true,
  "2012-04-30": false,
  "2012-05-01": false,
  "2012-05-28": false,
  "2012-08-20": false,
  "2012-10-22": false,
  "2012-10-23": false,
  "2012-10-27": true,
  "2012-11-01": false,
  "2012-11-02": false,
  "2012-11-10": true,
  "2012-12-01": true,
  "2012-12-15": true,
  "2012-12-24": false,
  "2012-12-25": false,
  "2012-12-26": false,
  "2013-01-01": false,
  "2013-03-15": false,
  "2013-03-31": false,
  "2013-04-01": false,
  "2013-05-01": false,
  "2013-05-20": false,
  "2013-08-19": false,
  "2013-08-20": false,
  "2013-08-24": true,
  "2013-10-23": false,
  "2013-11-01": false,
  "2013-12-07": true,
  "2013-12-21": true,
  "2013-12-24": false,
  "2013-12-25": false,
  "2013-12-26": false,
  "2013-12-27": false,
  "2014-01-01": false,
  "2014-03-15": false,
  "2014-04-20": false,
  "2014-04-21": false,
  "2014-05-01": false,
  "2014-05-02": false,
  "2014-05-10": true,
  "2014-06-09": false,
  "2014-08-20": false,
  "2014-10-18": true,
  "2014-10-23": false,
  "2014-10-24": false,
  "2014-11-01": false,
  "2014-12-13": true,
  "2014-12-24": false,
  "2014-12-25": false,
  "2014-12-26": false,
  "2015-01-01": false,
  "2015-01-02": false,
  "2015-01-10": true,
  "2015-03-15": false,
  "2015-04-05": false,
  "2015-04-06": false,
  "2015-05-01": false,
  "2015-05-25": false,
  "2015-08-08": true,
  "2015-08-20": false,
  "2015-08-21": false,
  "2015-10-23": false,
  "2015-11-01": false,
  "2015-12-12": true,
  "2015-12-24": false,
  "2015-12-25": false,
  "2015-12-26": false,
  "2016-01-01": false,
  "2016-03-05": true,
  "2016-03-14": false,
  "2016-03-15": false,
  "2016-03-27": false,
  "2016-03-28": false,
  "2016-05-01": false,
  "2016-05-16": false,
  "2016-08-20": false,
  "2016-10-15": true,
  "2016-10-23": false,
  "2016-10-31": false,
  "2016-11-01": false,
  "2016-12-25": false,
  "2016-12-26": false,
  "2017-03-15": false,
  "2017-04-14": false,
  "2017-04-17": false,
  "2017-05-01": false,
  "2017-06-05": false,
  "2017-10-23": false,
  "2017-11-01": false,
  "2017-12-25": false,
  "2017-12-26": false,
  "2018-01-01": false,
  "2018-03-10": true,
  "2018-03-15": false,
  "2018-03-16": false,
  "2018-03-30": false,
  "2018-04-02": false,
  "2018-04-21": true,
  "2018-04-30": false,
  "2018-05-01": false,
  "2018-05-21": false,
  "2018-08-20": false,
  "2018-10-13": true,
  "2018-10-22": false,
  "2018-10-23": false,
  "2018-11-01": false,
  "2018-11-02": false,
  "2018-11-10": true,
  "2018-12-01": true,
  "2018-12-15": true,
  "2018-12-24": false,
  "2018-12-25": false,
  "2018-12-26": false,
  "2018-12-31": false,
  "2019-01-01": false,
  "2019-03-15": false,
  "2019-04-19": false,
  "2019-04-22": false,
  "2019-05-01": false,
  "2019-06-10": false,
  "2019-08-10": true,
  "2019-08-19": false,
  "2019-08-20": false,
  "2019-10-23": false,
  "2019-11-01": false,
  "2019-12-07": true,
  "2019-12-14": true,
  "2019-12-24": false,
  "2019-12-25": false,
  "2019-12-26": false,
  "2019-12-27": false,
  "2020-01-01": false,
  "2020-04-10": false,
  "2020-04-13": false,
  "2020-05-01": false,
  "2020-06-01": false,
  "2020-08-20": false,
  "2020-08-21": false,
  "2020-08-29": true,
  "2020-10-23": false,
  "2020-12-12": true,
  "2020-12-24": false,
  "2020-12-25": false,
  "2021-01-01": false,
  "2021-03-15": false,
  "2021-04-02": false,
  "2021-04-05": false,
  "2021-05-01": false,
  "2021-05-24": false,
  "2021-08-20": false,
  "2021-10-23": false,
  "2021-11-01": false,
  "2021-12-11": true,
  "2021-12-24": false,
  "2021-12-25": false,
  "2021-12-26": false,
  "2022-01-01": false,
  "2022-03-14": false,
  "2022-03-15": false,
  "2022-03-26": true,
  "2022-04-15": false,
  "2022-04-18": false,
  "2022-05-01": false,
  "2022-06-06": false,
  "2022-08-20": false,
  "2022-10-15": true,
  "2022-10-23": false,
  "2022-10-31": false,
  "2022-11-01": false,
  "2022-12-24": false,
  "2022-12-25": false,
  "2022-12-26": false,
  "2023-01-01": false,
  "2023-03-15": false,
  "2023-04-07": false,
  "2023-04-09": false,
  "2023-04-10": false,
  "2023-05-01": false,
  "2023-05-28": false,
  "2023-05-29": false,
  "2023-08-20": false,
  "2023-10-23": false,
  "2023-11-01": false,
  "2023-12-25": false,
  "2023-12-26": false,
  "2024-01-01": false,
  "2024-03-15": false,
  "2024-04-01": false,
  "2024-05-01": false,
  "2024-05-20": false,
  "2024-08-03": true,
  "2024-08-19": false,
  "2024-08-20": false,
  "2024-10-23": false,
  "2024-11-01": false,
  "2024-12-07": true,
  "2024-12-14": true,
  "2024-12-24": false,
  "2024-12-25": false,
  "2024-12-26": false,
  "2024-12-27": false,
  "2025-01-01": false,
  "2025-04-18": false,
  "2025-04-21": false,
  "2025-05-01": false,
  "2025-05-02": false,
  "2025-05-17": true,
  "2025-06-09": false,
  "2025-08-20": false,
  "2025-10-18": true,
  "2025-10-23": false,
  "2025-10-24": false,
  "2025-12-13": true,
  "2025-12-24": false,
  "2025-12-25": false,
  "2025-12-26": false,
  "2026-01-01": false,
  "2026-01-02": false,
  "2026-01-10": true,
  "2026-03-15": false,
  "2026-04-03": false,
  "2026-04-06": false,
  "2026-05-01": false,
  "2026-05-25": false,
  "2026-08-08": true,
  "2026-08-20": false,
  "2026-08-21": false,
  "2026-10-23": false,
  "2026-11-01": false,
  "2026-12-12": true,
  "2026-12-24": false,
  "2026-12-25": false,
  "2026-12-26": false,
};

export function calculateWorkdays(from: Moment, to: Moment): number {
  let negative = 1;
  if (to.isBefore(from)) {
    const fromClone = from.clone();
    from = to.clone();
    to = fromClone;
    negative = -1;
  }
  const act = from.clone();
  let cnt = 0;
  while (act.isSameOrBefore(to, "days")) {
    if (isWorkday(act)) {
      cnt++;
    }
    act.add(1, "days");
  }
  return cnt * negative;
}

export function isWorkdayCalculationSupported(from: Moment, to?: Moment) {
  if (!to) {
    to = from.clone();
  }
  const tzOk = from.tz() === SUPPORTED_TZ && to.tz() === SUPPORTED_TZ;
  const intervalOk = from.year() >= MIN_YEAR && from.year() <= MAX_YEAR &&
    to.year() <= MAX_YEAR && to.year() >= MIN_YEAR;
  return tzOk && intervalOk;
}

export function isWorkday(date: Moment): boolean {
  const day = date.day()
  const dateStr = date.format("YYYY-MM-DD");
  if (dateStr in SPECIAL_DAYS) {
    return SPECIAL_DAYS[dateStr];
  }
  return day !== 6 && day !== 0;
}


// WEBPACK FOOTER //
// ./src/Calculator/specialDays.ts